import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface UpiPaymentMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface UpiPaymentMst {
    id?: any;
    name:string;
    isActive:string;
    countryId:string;
    parameters?: UpiPaymentMstParameter[];
    links?: any;
}


export abstract class UpiPaymentMstData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(): Observable<UpiPaymentMst[]>;
    abstract create(url: string, data: UpiPaymentMst): Observable<UpiPaymentMst[]>;
    abstract update(url: string, data: UpiPaymentMst): Observable<UpiPaymentMst[]>;
    abstract delete(url: string): Observable<any>;
}
